import React from "react";
import {  Form } from "react-bootstrap";
import { StyleSheet, css } from "aphrodite";
import GlobalSlider from "../../GenericComponents/GlobalSlider";
import styles from "../style";

class LowHRThresholdCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { lowHRSettings, defaultSettings, handleSliderValues } = this.props;
    const min = parseInt(defaultSettings.LOW_HR_THRESHOLD.minValue);
    const max = parseInt(defaultSettings.LOW_HR_THRESHOLD.maxValue);
    const step = 5;
    const lowHRThresholdValue =
      typeof lowHRSettings.lowHRThreshold === "number"
        ? lowHRSettings.lowHRThreshold
        : parseInt(lowHRSettings.lowHRThreshold ?? 0);
    return (
      Object.keys(lowHRSettings).length !== 0 && (
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <label
              className={css(styles.valueLabels)}
              style={{ paddingTop: 20 }}
            >
              Low HR Threshold Event value (
              {defaultSettings.LOW_HR_THRESHOLD.minValue} -{" "}
              {defaultSettings.LOW_HR_THRESHOLD.maxValue}{" "}
              {defaultSettings.LOW_HR_THRESHOLD.unit})
            </label>
            <Form.Select
              name="lowHRThreshold"
              style={{ width: 140 }}
              value={
                Number.isFinite(lowHRThresholdValue) ? lowHRThresholdValue : 0
              }
              onChange={(e) =>
                handleSliderValues(
                  "lowHRThreshold",
                  parseInt(e.target.value, 10),
                )
              }
            >
              <option value={0}>OFF</option>
              {Array.from(
                { length: Math.floor((max - min) / step) + 1 },
                (_, idx) => min + idx * step,
              ).map((v) => (
                <option key={v} value={v}>
                  {v}
                </option>
              ))}
            </Form.Select>
          </div>
          <label
            style={{ fontSize: "14px", marginBottom: "1em", color: "black" }}
          >
            How long should low HR last before alert. Choose{" "}
            {defaultSettings.LOW_HR_THRESHOLD_DURATION.minValue} -{" "}
            {defaultSettings.LOW_HR_THRESHOLD_DURATION.maxValue}{" "}
            {defaultSettings.LOW_HR_THRESHOLD_DURATION.unit}.<br />
          </label>
          <GlobalSlider
            name={"lowHRThresholdDuration"}
            min={parseInt(defaultSettings.LOW_HR_THRESHOLD_DURATION.minValue)}
            max={parseInt(defaultSettings.LOW_HR_THRESHOLD_DURATION.maxValue)}
            value={lowHRSettings.lowHRThresholdDuration}
            step={1}
            action={handleSliderValues}
          />
        </div>
      )
    );
  }
}

export default LowHRThresholdCard;

const style = StyleSheet.create({
  title: {
    fontSize: "18px",
    color: "white",
  },
  subTitle: {
    fontSize: "12px",
    color: "white",
  },
  headerStyle: {
    background: "#0d6cbf",
    margin: "-1px",
  },
  footerStyles: {
    display: "block !important",
    textAlign: "center",
  },
});
